<template>
  <v-container class="d-flex flex-column ga-3">
    <UsageExample v-model="tab" :code="code" :tabs="tabs">
      <v-row>
        <v-col>
          <v-card elevation="4" class="pa-2 mx-auto" min-height="220" width="400">
            <v-card-title class="font-weight-bold">Date Picker</v-card-title>
            <v-card-text>
              <hx-date-picker
                v-model="dateValue"
                :mode="mode"
                :label="label"
                :placeholder="placeholder"
                :helper-message="showHelperMessage ? 'Helper message' : undefined"
                :error-message="showErrorMessage ? 'Error message' : undefined"
                :optional="optional"
                :mandatory="mandatory"
                :disabled="disabled"
                :readonly="readonly"
                :min="useDateRange ? minDate : undefined"
                :max="useDateRange ? maxDate : undefined"
                @update:model-value="handleDateUpdate"
              />
            </v-card-text>
            <v-card-text v-if="hasSelectedValue" class="pt-0 text-caption">
              Selected value: {{ formattedSelectedValue }}
            </v-card-text>
            <v-card-text v-if="useDateRange" class="pt-0 text-caption text-medium-emphasis">
              Allowed range: {{ minDate }} to {{ maxDate }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <template #configuration>
        <div class="d-flex flex-column ga-2">
          <v-radio-group v-model="mode" label="Mode" hide-details density="compact">
            <v-radio label="Single" value="single" />
            <v-radio label="Range" value="range" />
          </v-radio-group>

          <v-divider class="my-2" />

          <v-checkbox v-model="optional" label="Optional" hide-details />
          <v-checkbox v-model="mandatory" label="Mandatory" hide-details />
          <v-checkbox v-model="showHelperMessage" label="Helper Message" hide-details />
          <v-checkbox v-model="showErrorMessage" label="Error Message" hide-details />
          <v-checkbox v-model="disabled" label="Disabled" hide-details />
          <v-checkbox v-model="readonly" label="Read-only" hide-details />

          <v-divider class="my-2" />

          <v-checkbox v-model="useDateRange" label="Min / max date range" hide-details />

          <v-text-field
            v-model="minDate"
            label="Min date (YYYY-MM-DD)"
            density="compact"
            variant="outlined"
            hide-details
            :disabled="!useDateRange"
          />
          <v-text-field
            v-model="maxDate"
            label="Max date (YYYY-MM-DD)"
            density="compact"
            variant="outlined"
            hide-details
            :disabled="!useDateRange"
          />
        </div>
      </template>
    </UsageExample>
  </v-container>
</template>

<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'HelixDatePicker',
  components: { UsageExample },

  setup() {
    const code = `
// Single Date Picker
<hx-date-picker
  v-model="dateValue"
  :label="label"
  placeholder="DD MMM YYYY"
  :helper-message="showHelperMessage ? 'Helper message' : undefined"
  :error-message="showErrorMessage ? 'Error message' : undefined"
  :optional="optional"
  :mandatory="mandatory"
  :disabled="disabled"
  :readonly="readonly"
  min="2020-01-01"
  max="2030-12-31"
  @update:model-value="handleDateUpdate"
/>

// Range Date Picker
<hx-date-picker
  v-model="dateValue"
  mode="range"
  :label="label"
  placeholder="DD MMM YYYY"
  :helper-message="showHelperMessage ? 'Helper message' : undefined"
  :error-message="showErrorMessage ? 'Error message' : undefined"
  :optional="optional"
  :mandatory="mandatory"
  :disabled="disabled"
  :readonly="readonly"
  min="2020-01-01"
  max="2030-12-31"
  @update:model-value="handleDateUpdate"
/>`;

    return {
      code
    };
  },

  data() {
    return {
      tab: 'Date Picker Usage',
      tabs: ['Date Picker Usage'],
      mode: 'single',
      label: 'Incident date',
      placeholder: 'DD MMM YYYY',
      showHelperMessage: false,
      showErrorMessage: false,
      optional: false,
      mandatory: false,
      disabled: false,
      readonly: false,
      useDateRange: true,
      minDate: '2020-01-01',
      maxDate: '2030-12-31',
      dateValue: '2024-06-15'
    };
  },

  computed: {
    hasSelectedValue() {
      if (this.mode === 'range') {
        return Boolean(this.dateValue?.start && this.dateValue?.end);
      }

      return Boolean(this.dateValue);
    },

    formattedSelectedValue() {
      if (this.mode === 'range' && this.dateValue?.start && this.dateValue?.end) {
        return `{ start: '${this.dateValue.start}', end: '${this.dateValue.end}' }`;
      }

      return this.dateValue;
    }
  },

  watch: {
    mode(newMode) {
      if (newMode === 'range') {
        this.label = 'Reporting period';
        this.dateValue = { start: '2024-01-01', end: '2024-01-31' };
        return;
      }

      this.label = 'Incident date';
      this.dateValue = '2024-06-15';
    }
  },

  methods: {
    handleDateUpdate(value) {
      this.dateValue = value;
      console.log('Date value updated:', value);
    }
  }
};
</script>
